import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { CoreFlightSteps } from "@b2bportal/core-utilities";

import { useI18nContext } from "@hopper-b2b/i18n";
import {
  FlightReviewPageContent,
  FlightShopBreadcrumbs,
} from "@tenant/flights";
import { Page } from "@tenant/ui";
import clsx from "clsx";
import { useFlightSlot } from "../../slots";
import {
  FlightRawEventName,
  useEmitCoreFlightRawEventOnce,
} from "../../tracking";
import defaultStyles from "./ReviewPage.module.scss";
import type { ReviewPageProps } from "./types";

export type ReviewPageComponentProps = PlatformComponentProps & ReviewPageProps;

export const ReviewPage = ({
  context,
  handlers,
  children,
  className,
}: ReviewPageComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.ReviewPage;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const currentStep = CoreFlightSteps.REVIEW;

  const { t } = useI18nContext();

  const FlightSlots = useFlightSlot();

  useEmitCoreFlightRawEventOnce({ name: FlightRawEventName.ViewedTripSummary });

  return (
    <Page
      title={t("flightsPageTitles.reviewItinerary")}
      className={clsx(block, className)}
    >
      <div className={cn("container")}>
        <FlightShopBreadcrumbs
          className={cn("breadcrumbs")}
          currentStep={currentStep}
        />
        <FlightSlots.ReviewFlightHeader className={cn("header")} />
        <FlightReviewPageContent
          context={context}
          handlers={handlers}
          classNames={{
            itinerary: cn("itinerary"),
            secondaryContent: cn("secondary-content"),
            hackerFareWarning: cn("review-warning"),
            virtualInterliningWarning: cn("flight-combination"),
            loading: cn("loading"),
          }}
        />
        {children}
      </div>
    </Page>
  );
};
